export const env = {
  BUGSNAG_KEY: process.env.BUGSNAG_KEY,
  BACKEND_SERVER: process.env.BACKEND_SERVER,
};
